import { Component, Input, OnInit } from "@angular/core";
import { FromToDetail } from "../../../../../_objects/report-element";
import { ReportMeasurementPoint } from "../../../../models/report-preview/report-measurement-point";
import { Notifier, OfflineReportPreviewService, MousePoint } from "../../../../../_services/offline-report-preview.service";

@Component({
  selector: "app-report-measurement-points",
  templateUrl: "./report-measurement-points.component.html",
  styleUrls: ["./report-measurement-points.component.scss"],
  standalone: false
})
export class ReportMeasurementPointOfflineComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public measurementPointKey: string;
  @Input() public elementLocation: string;

  public notifier: Notifier;
  public reportMeasurementPoint: ReportMeasurementPoint;
  public resizeMarkerSize: number;
  public resizing: boolean;

  readonly dynamicMarkStyle =
    "position: absolute; background-image: linear-gradient(-135deg, #87ceeb 4.5px, transparent 0), linear-gradient(45deg, #87ceeb 4.5px, transparent 0);";

  constructor(public designService: OfflineReportPreviewService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: "report-measurement-points.component",
      ids: { pageId: this.pageKey, elementId: this.measurementPointKey }
    };
    // this.reportMeasurementPoint = this.designService.getMeasurementPoints(this.measurementPointKey);
  }

  public onClick(event: MouseEvent) {}

  public onDragStart(event: DragEvent) {
    // console.log('ReportImage onDragStart');
    event.dataTransfer.setData("measurementPoint", this.measurementPointKey);
    event.dataTransfer.effectAllowed = "move";

    const fromDetail: FromToDetail = {
      location: this.reportMeasurementPoint.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
  }

  public onDragOver(event: DragEvent) {
    // console.log('ReportImage onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    // console.log('ReportImage onDrop');
    event.preventDefault();
    const template = { ...this.designService.originTemplate };
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    const dragElemId = event.dataTransfer.getData("measurementPoint");

    const toDetail: FromToDetail = {
      location: this.reportMeasurementPoint.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportMeasurementPoint.getLeftPx() + event.offsetX,
      onElementY: this.reportMeasurementPoint.getTopPx() + event.offsetY
    };

    event.dataTransfer.clearData("measurementPoint");
    event.stopPropagation();
  }

  public getStyles(reportMeasurementPoint: ReportMeasurementPoint): object {
    return {
      width: reportMeasurementPoint.tableWidth,
      fontSize: reportMeasurementPoint.fontSize,
      fontFamily: reportMeasurementPoint.fontFamily,
      border: `${reportMeasurementPoint.tableBorderWidth}mm ${reportMeasurementPoint.tableBorderStyle} ${reportMeasurementPoint.tableBorderColor}`,
      padding: `${reportMeasurementPoint.tableMargin}mm`
    };
  }

  public getContainerStyle(reportMeasurementPoint: ReportMeasurementPoint): object {
    return {
      top: 0,
      left: 0,
      width: reportMeasurementPoint.width,
      height: reportMeasurementPoint.height
    };
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + "px";
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case "left":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "center":
        return this.reportMeasurementPoint.getWidthPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "right":
        return this.reportMeasurementPoint.getWidthPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case "top":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "middle":
        return this.reportMeasurementPoint.getHeightPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "bottom":
        return this.reportMeasurementPoint.getHeightPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };

    event.stopPropagation();
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }
}
